import { AppStrings } from "../utils/constants/AppStrings";
import { FEATURE_GUARD_ALLOWED_ENVIRONMENTS } from "../utils/Constants";

// Pure predicate so non-React code can reuse the same check.
export function isDevModeEnv(): boolean {
  const name = (AppStrings?.PAM_APP_NAME ?? "").toLowerCase();
  return (FEATURE_GUARD_ALLOWED_ENVIRONMENTS as readonly string[]).some(
    (env) => name.includes(env.toLowerCase()),
  );
}

export function useIsDevMode(): boolean {
  return isDevModeEnv();
}

export default useIsDevMode;
